export default __webpack_public_path__ + "34504a8ea2791808b2031ee7af09c936.png";